<script lang="ts" setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()

appStore.setCurrentSize('small')
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>

<style>
.space-min-top {
  margin-top: 4px !important;
}

.space-top {
  margin-top: 20px !important;
}

.space-left1 {
  margin-left: 10px;
}

.space-left2 {
  margin-left: 20px !important;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ps {
  font-size: 12px;
  color: red;
}

.short-input {
  width: 120px !important;
}

.mid-input {
  width: 200px !important;
}

.long-input {
  width: 300px !important;
}

.w-400px {
  width: 400px !important;
}

.max-input {
  width: 500px !important;
}
</style>
